module.exports = "https://redage.akamaized.net/src/views/casino/jacpot/logo.svg";